// extracted by mini-css-extract-plugin
export default {"heading":"heading_heading__U9ct3","headingWhite":"heading_headingWhite__0qKON","h1":"heading_h1__PLyxO","h2":"heading_h2__pKkZt","h3":"heading_h3__MBTXp"};